import { Component } from '@angular/core';
import { CredentialType } from 'enums/CredentialType';
import { CompanyModel } from 'models/generated/Entities.GormCrm.Company';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { Pipes } from 'modules/pipes';
import { BrandService } from 'services/brand.service';
import { CompanyService } from 'services/company.service';
import { CredentialRequired } from 'services/credential.service';
import { InvoicingService } from 'services/invoicing.service';
import { ComponentUrl } from 'services/navigation.service';

@ComponentUrl('overridden-due-dates')
@CredentialRequired(CredentialType.CreateInvoiceObjection)
@Component({
	templateUrl: './overridden-due-dates.component.html',
	imports: [Layout, ListView, Pipes]
})
export class OverriddenDueDatesComponent {

	public customers?: { company?: CompanyModel; customerNumber: string, invoiceNumber: string; dueDate?: Date; }[];
	constructor(brandService: BrandService, invoicingService: InvoicingService, companyService: CompanyService) {

		
		invoicingService.getInvoicesWithOverriddenDueDates(brandService.brands.find(b => b.shortName == 'WK')?.id!).then(async customers => {

			const companies = await companyService.getCompaniesByIds(customers.flatMap(c => c.companyId));

			this.customers = customers.flatMap(customer => customer.ledgerHeaders.map(header => {
				return {
					company: companies.find(c => c.id == customer.companyId),
					customerNumber: customer.customerNumber,
					invoiceNumber: header.postedDocumentNo,
					dueDate: header.dueDate
				};
			}));
		});
	}

	getInvoiceUrl(customerNumber: string) {
		return `https://secure.e-conomic.com/sales/customers/${customerNumber}/entries`;
	}
}
